import { memo } from "react";
interface Props {
  className?: string;
  color?: string;
}
function FollowupAppointmentIcon({ className, color }: Props) {
  return (
    <svg
      className={className}
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.289062"
        width="39.2346"
        height="40"
        rx="5"
        fill={color || '#50B8E7'}
        fillOpacity="0.05"
      />
      <g clipPath="url(#clip0_3581_48342)">
        <path
          d="M28.1801 18.19C27.4608 18.0598 26.7311 17.9962 26.0001 18C25.5801 18 25.1701 18 24.7601 18.08C24.2497 17.3989 23.5982 16.836 22.8501 16.43C23.4927 15.7283 23.8494 14.8115 23.8501 13.86C23.8501 12.8363 23.4435 11.8545 22.7196 11.1306C21.9957 10.4067 21.0139 10 19.9901 10C18.9664 10 17.9846 10.4067 17.2607 11.1306C16.5368 11.8545 16.1301 12.8363 16.1301 13.86C16.1309 14.8115 16.4876 15.7283 17.1301 16.43C16.3865 16.8382 15.7361 17.3967 15.2201 18.07C14.8301 18 14.4201 18 14.0001 18C13.2686 18.0028 12.5388 18.0731 11.8201 18.21C11.5872 18.2526 11.3769 18.3765 11.2267 18.5596C11.0766 18.7427 10.9963 18.9732 11.0001 19.21V27.46C10.9999 27.6069 11.032 27.7521 11.0942 27.8852C11.1565 28.0182 11.2473 28.136 11.3601 28.23C11.4723 28.3246 11.6039 28.3933 11.7456 28.4313C11.8873 28.4694 12.0357 28.4757 12.1801 28.45C12.7785 28.3197 13.3879 28.246 14.0001 28.23C15.9372 28.2279 17.8323 28.7947 19.4501 29.86L19.5801 29.91C19.7128 29.9676 19.8555 29.9982 20.0001 30C20.0956 29.9988 20.1902 29.9819 20.2801 29.95H20.3501L20.4801 29.9C22.1134 28.8073 24.0351 28.2259 26.0001 28.23C26.6111 28.2328 27.2204 28.2931 27.8201 28.41C27.9646 28.4357 28.1129 28.4294 28.2546 28.3913C28.3964 28.3533 28.528 28.2846 28.6401 28.19C28.753 28.096 28.8438 27.9782 28.906 27.8452C28.9682 27.7121 29.0004 27.5669 29.0001 27.42V19.17C28.9993 18.9366 28.9168 18.7109 28.7671 18.5319C28.6173 18.353 28.4097 18.232 28.1801 18.19ZM20.0001 12C20.4686 12.0344 20.9067 12.2448 21.2264 12.5889C21.5461 12.933 21.7238 13.3853 21.7238 13.855C21.7238 14.3247 21.5461 14.777 21.2264 15.1211C20.9067 15.4652 20.4686 15.6756 20.0001 15.71C19.5317 15.6756 19.0936 15.4652 18.7739 15.1211C18.4541 14.777 18.2764 14.3247 18.2764 13.855C18.2764 13.3853 18.4541 12.933 18.7739 12.5889C19.0936 12.2448 19.5317 12.0344 20.0001 12ZM19.0001 27.33C17.4328 26.6055 15.7268 26.2302 14.0001 26.23C13.6701 26.23 13.3401 26.23 13.0001 26.28V20C13.8387 19.9062 14.686 19.923 15.5201 20.05H15.6301C16.8217 20.269 17.9636 20.7027 19.0001 21.33V27.33ZM20.0001 19.6C19.5555 19.3435 19.0945 19.1163 18.6201 18.92H18.5601C18.2301 18.79 17.9001 18.66 17.5601 18.56C18.2544 18.0074 19.1128 17.7013 20.0001 17.69C20.8851 17.6956 21.7432 17.9945 22.4401 18.54C21.5912 18.805 20.7732 19.1604 20.0001 19.6ZM27.0001 26.28C24.9468 26.0737 22.8756 26.4189 21.0001 27.28V21.28C22.0385 20.6688 23.1811 20.2552 24.3701 20.06H24.5701C25.3741 19.9348 26.191 19.9146 27.0001 20V26.28Z"
          fill={color || '#50B8E7'}
          />
      </g>
      <defs>
        <clipPath id="clip0_3581_48342">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(7.90625 8)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export default memo(FollowupAppointmentIcon);
